module.exports = __webpack_public_path__ + "img/Button_Stop.f6d5ab14.png";